import Immutable from 'immutable';
import { createSelector } from 'reselect';
import {
  selectCurrentCoursePath,
  selectIsAdminOfCurrentCourse,
} from '../Courses/selectors';
import { selectIsFacilitatorInCurrentCourse } from '../Enrolments/selectors';

import {
  currentCohortScheduleSelector,
  currentCohortModuleStartDatesSelector,
  currentCohortSchedulingListByPagePathSelector,
} from '../CohortSchedules/selectors';
import { getModuleDisplayData, getModulesBySet } from './helpers';

const moduleProgressSelector = (state) => state.ModuleProgress;

export const currentCourseModuleListIsLoadingSelector = createSelector(
  selectCurrentCoursePath,
  moduleProgressSelector,
  (coursePath, moduleProgress) =>
    moduleProgress.getIn([coursePath, 'isLoading'], false)
);

export const currentCourseModuleListSelector = createSelector(
  selectCurrentCoursePath,
  moduleProgressSelector,
  (coursePath, modules) =>
    (modules && modules.getIn([coursePath, 'moduleList'])) || Immutable.List()
);

export const currentCourseModulesBySetSelector = createSelector(
  [currentCourseModuleListSelector],
  getModulesBySet
);

export const currentCourseModuleDisplayDataBySetSelector = createSelector(
  currentCourseModuleListSelector,
  currentCourseModulesBySetSelector,
  currentCohortScheduleSelector,
  currentCohortModuleStartDatesSelector,
  currentCohortSchedulingListByPagePathSelector,
  selectIsAdminOfCurrentCourse,
  selectIsFacilitatorInCurrentCourse,
  (
    moduleList,
    modulesBySet,
    schedule,
    moduleStartDates,
    schedulingList,
    isCourseAdmin,
    isFacilitator
  ) => {
    // TODO: rewrite helper and tests to work with Immutable ...
    return modulesBySet.map((modulesInSet) =>
      Immutable.fromJS(
        getModuleDisplayData(
          moduleList.toJS(),
          modulesInSet.toJS(),
          schedule.toJS(),
          moduleStartDates,
          schedulingList,
          isCourseAdmin || isFacilitator
        )
      )
    );
  }
);
